// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__xUnDP","appName":"Header_appName__2ro7V","logo":"Header_logo__J93m8","actions":"Header_actions__1Py27"};